"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Label", {
    enumerable: true,
    get: function() {
        return Label;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useLabel = require("./useLabel");
const _renderLabel = require("./renderLabel");
const _useLabelStylesstyles = require("./useLabelStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Label = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useLabel.useLabel_unstable)(props, ref);
    (0, _useLabelStylesstyles.useLabelStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useLabelStyles_unstable')(state);
    return (0, _renderLabel.renderLabel_unstable)(state);
});
Label.displayName = 'Label';
